// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".StepStackItemGroup-base__JJ7zY{display:flex;overflow-x:auto;overflow-y:hidden;scrollbar-width:none;-ms-overflow-style:none}.StepStackItemGroup-base__JJ7zY::-webkit-scrollbar{display:none}.StepStackItemGroup-content___uATW{display:flex;flex:1 0 0;width:var(--size-full);max-width:calc(var(--size-10)*13 + var(--size-2));margin-right:auto;margin-left:auto;padding:var(--size-0) var(--size-4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "StepStackItemGroup-base__JJ7zY",
	"content": "StepStackItemGroup-content___uATW"
};
export default ___CSS_LOADER_EXPORT___;
